import { render, staticRenderFns } from "./Reiting.vue?vue&type=template&id=6b27e777&scoped=true&"
import script from "./Reiting.vue?vue&type=script&lang=js&"
export * from "./Reiting.vue?vue&type=script&lang=js&"
import style0 from "./Reiting.vue?vue&type=style&index=0&id=6b27e777&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b27e777",
  null
  
)

export default component.exports